const COMPONENT_NAME = "Divider";
export {
  COMPONENT_NAME
};
